/**
 * Progress ring
 */

class ProgressRing extends HTMLElement {

    constructor() {
        super();

        // get config from attributes
        const meterColor = this.getAttribute('meter-color') || 'transparent';
        const fillColor = this.getAttribute('fill-color') || 'black';
        const stroke = this.getAttribute('stroke');
        const radius = this.getAttribute('radius');
        const normalizedRadius = radius - stroke;
        this._circumference = normalizedRadius * 2 * Math.PI;

        // create shadow dom root
        this._root = this.attachShadow({mode: 'open'});
        this._root.innerHTML = `
            <svg class="progress-ring" height="${radius * 2}" width="${radius * 2}">
                <circle
                    class="progress-ring__meter"
                    stroke="${meterColor}"
                    stroke-width="${stroke}"
                    fill="transparent"
                    r="${normalizedRadius}"
                    cx="${radius}"
                    cy="${radius}"
                />
                <circle
                    class="progress-ring__fill"
                    stroke="${fillColor}"
                    stroke-dasharray="${this._circumference} ${this._circumference}"
                    style="stroke-dashoffset:${this._circumference}"
                    stroke-width="${stroke}"
                    fill="transparent"
                    r="${normalizedRadius}"
                    cx="${radius}"
                    cy="${radius}"
                />
                <style>
                    circle.progress-ring__fill {
                        transition: stroke-dashoffset 0.35s;
                        transform: rotate(-90deg);
                        transform-origin: 50% 50%;
                    }
                </style>
            </svg>
        `;
    }

    setProgress(percent) {
        const offset = this._circumference - (percent / 100 * this._circumference);
        const fill = this._root.querySelector('circle.progress-ring__fill');
        fill.style.strokeDashoffset = offset;
    }

    static get observedAttributes() {
        return ['progress'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if ( name === 'progress' ) {
            this.setProgress(newValue);
        }
    }

}

window.customElements.define('progress-ring', ProgressRing);
